import React, { useState, useEffect, useRef } from "react";
import Skeleton from "react-loading-skeleton";
import StarIcon from "@mui/icons-material/Star";
import { useNavigate } from "react-router-dom";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import WifiIcon from "@mui/icons-material/Wifi";
import Slider from "../../components/newSlider.jsx";
import { axios } from "../../utils/axios.js";
import { useLocation } from "react-router-dom";
import { iconMapping } from "../../utils/icons.js";
import { format, parseISO } from "date-fns";
import GoogleMap from "../../components/GoogleMap.jsx";
import { toast } from "react-toastify";
import IMG from "../../assets/images/serachList/noImage.jpg";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { createOccupancies, formatDateToEEE_MM_d } from "../../utils/utils.jsx";
import { useAuth } from "../../context";
import { useSelector, useDispatch } from "react-redux";
import Modal from "../../components/Modal.jsx";
import Spinner from "../../components/Spinner";
import Search from "../../components/Search.jsx";
import { getDayDifference } from "../../utils/utils";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import GridViewIcon from "@mui/icons-material/GridView";
import "./searchdetail.css";
import NOHOTELIMG from "../../assets/images/serachList/noHotel.svg";
import ShareIcon from "@mui/icons-material/Share";
import { setSelectedCurrency } from "../../redux/slices/currency";
const SearchDetail = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [hotelDetails, setHotelDetails] = useState();
  const [roomDetails, setRoomDetails] = useState();
  const url = useLocation();
  const { token: contextToken } = useAuth();
  const reduxToken = useSelector((state) => state.auth.token);
  const queryParams = new URLSearchParams(url.search);
  const tid = JSON.parse(queryParams.get("tid"));
  const hid = JSON.parse(queryParams.get("hid"));
  const [token, setToken] = useState(JSON.parse(queryParams.get("tkid")));
  const checkIn = JSON.parse(queryParams.get("checkin"));
  const checkOut = JSON.parse(queryParams.get("checkout"));
  const occupancy = JSON.parse(queryParams.get("oc"));
  const currency = queryParams.get("currency");
  const [cid, setCid] = useState(JSON.parse(queryParams.get("cid")));
  const locid = JSON.parse(queryParams.get("locid"));
  const directSearch = queryParams.get("ds");
  const roomsRef = useRef(null);
  const [showAll, setShowAll] = useState(false);
  const [tripId, setTripId] = useState(JSON.parse(queryParams.get("tid")));
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [roomImages, setRoomImages] = useState([]);
  const [reserveLoader, setReserveLoader] = useState(false);
  const [openLogin, setOpenLogin] = useState(false);
  const [showPhotoModal, setShowPhotoModal] = useState(false); // For gallery modal
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0); // Track the current photo in the gallery modal
  const [validImages, setValidImages] = useState([]); // Track indices of images that fail to load
  const thumbnailsRef = useRef(null); // Ref for the thumbnail container to handle scrolling
  const [visibleImages, setVisibleImages] = useState(6); // Number of smaller images to show
  const [error, setError] = useState(false);
  const { currencies, selectedCurrency } = useSelector(
    (state) => state.currency
  );
  const handleShowAll = () => setShowAll(!showAll);

  const checkdates = [
    {
      startDate: checkIn !== null ? parseISO(checkIn) : null,
      endDate: checkOut !== null ? parseISO(checkOut) : null,
      key: "selection",
    },
  ];
  // Detect screen size to adjust the number of visible images
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width <= 576) {
        setVisibleImages(0); // No smaller images
      } else if (width <= 768) {
        setVisibleImages(2); // Show 2 images
      } else if (width <= 992) {
        setVisibleImages(4); // Show 4 images
      } else {
        setVisibleImages(6); // Show 6 images
      }
    };

    // Initial check
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (currencies.length > 0 && currency) {
      const currencyResult = currencies.find((item) => item.code === currency);
      if (currencyResult) {
        dispatch(setSelectedCurrency(currencyResult));
      }
    }
  }, [currencies, currency, dispatch]);
  // Calculate the number of remaining images
  const remainingImagesCount = hotelDetails?.images?.length
    ? Math.max(0, hotelDetails.images.length - (visibleImages + 1)) // +1 for the main image
    : 0;

  useEffect(() => {
    setLoader(true);
    setError("");
    const fetchData = async () => {
      const childages = occupancy?.children.map((child) => child.age);
      const oc = createOccupancies(
        occupancy?.rooms,
        occupancy?.adults,
        childages
      );

      axios
        .post(process.env.REACT_APP_BACKEND_ZENTRUM + "gethoteldetails", {
          hotelIds: [hid],
          token: JSON.parse(directSearch) === true ? null : token,
          contentFields: ["all"],
          occupancies: oc,
          checkIn: checkIn,
          checkOut: checkOut,
          directSearch: JSON.parse(directSearch),
          tripId: tid,
          cid: cid,
        })
        .then((resp) => {
          setHotelDetails(resp?.data?.data?.hotels);
          const imageUrls = resp?.data?.data?.hotels?.roomImages.map(
            (item) => item.url
          );
          if (resp.data?.data?.token) {
            setToken(resp.data?.data?.token);
          }
          setRoomImages(imageUrls);
          let inputArray = resp?.data?.data?.roomsAndRates;

          if (inputArray && inputArray?.length !== 0) {
            const groupedArray = Object.values(
              inputArray.reduce((acc, item) => {
                const { name, images, stdRoomId, ...roomDetails } = item;
                if (!acc[stdRoomId]) {
                  acc[stdRoomId] = {
                    name,
                    images: new Set(),
                    rooms: [],
                  };
                }

                images?.forEach((image) => acc[stdRoomId].images.add(image));

                acc[stdRoomId].rooms.push({
                  name,
                  images,
                  ...roomDetails,
                });
                return acc;
              }, {})
            ).map((group) => {
              const sortedRooms = group.rooms.sort(
                (a, b) =>
                  (a.rate?.totalRate || a.totalRate) -
                  (b.rate?.totalRate || b.totalRate)
              );

              return {
                ...group,
                images: Array.from(group.images),
                rooms: sortedRooms,
                lowestRate:
                  sortedRooms[0]?.rate?.totalRate ||
                  sortedRooms[0]?.totalRate ||
                  Infinity,
              };
            });
            const filteredHotelData = groupedArray.map((hotel) => {
              // Group rooms by unique boardBasis+refundability type
              const grouped = {
                Refundable_BedAndBreakfast: null,
                NonRefundable_BedAndBreakfast: null,
                Refundable_RoomOnly: null,
                NonRefundable_RoomOnly: null,
                Refundable_AllInclusive: null,
                NonRefundable_AllInclusive: null,
                Refundable_FullBoard: null,
                NonRefundable_FullBoard: null,
              };

              hotel.rooms.forEach((room) => {
                const key = `${room.refundability}_${room.boardBasis.type}`;
                if (
                  grouped[key] === null ||
                  room?.totalRate < grouped[key]?.totalRate
                ) {
                  grouped[key] = room;
                }
              });

              // Filter out any null values and sort by totalRate ascending
              const filteredRooms = Object.values(grouped)
                .filter((room) => room !== null)
                .sort((a, b) => a.totalRate - b.totalRate);

              return {
                ...hotel,
                rooms: filteredRooms,
              };
            });
            const sortedGroups = filteredHotelData.sort(
              (a, b) => a.lowestRate - b.lowestRate
            );

            setRoomDetails(sortedGroups);
            setLoader(false);
            if (!cid) {
              setCid(resp?.data?.data?.cid);
            }
          } else {
            setLoader(false);
            setError(
              "We're sorry, but this property has no availability for the selected search criteria."
            );
          }
        })
        .catch((err) => {
          console.log(err);
          setLoader(false);
          setError(
            "We're sorry, but this property has no availability for the selected search criteria."
          );
        });
    };

    fetchData();
  }, [
    checkIn,
    checkOut,
    occupancy?.rooms,
    occupancy?.adults,
    occupancy?.children.length,
  ]);

  const scrollToRooms = () => {
    roomsRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const shareHotel = async () => {
    try {
      const currentUrl = window.location.href;
      const parsedUrl = new URL(currentUrl);
      parsedUrl.searchParams.delete("tkid");
      const cleanedUrl = parsedUrl.toString();
      await navigator.clipboard.writeText(cleanedUrl);
      toast.success("Copied to clipboard!");
    } catch (err) {
      console.error("Failed to copy!", err);
      toast.error("Failed to copy!");
    }
  };

  const addRoom = () => {
    if (selectedRoom) {
      addRoomApi();
    } else if (!reduxToken || !contextToken) {
      setOpenLogin(true);
    } else {
      toast.error("Please select a room");
    }
  };

  const addRoomApi = (tid) => {
    setReserveLoader(true);
    const data = {
      tripId: tripId || tid,
      checkIn: formatDateToEEE_MM_d(checkIn, "UTC", "iso"),
      checkOut: formatDateToEEE_MM_d(checkOut, "UTC", "iso"),
      hotelData: { hotels: hotelDetails, savedRoom: selectedRoom },
      token: token,
      quantity: 1,
      reqOccupancies: occupancy,
      cid: cid,
    };
    axios
      .post(
        process.env.REACT_APP_BACKEND + "roomsandrates/updatebillcarddetails",
        data
      )
      .then((resp) => {
        setReserveLoader(false);
        let queryParams = [];
        if (tripId || tid) {
          queryParams.push(`tid=${tripId || tid}`);
        }

        // queryParams.push(`tkid=${token}`);
        queryParams.push(`oc=${JSON.stringify(occupancy)}`);
        queryParams.push(`cid=${JSON.stringify(cid)}`);
        queryParams.push(`sid=${resp?.data?.savedRoomId || ""}`);
        queryParams.push(`currency=${selectedCurrency?.code || ""}`);

        navigate(`/review-booking?${queryParams.join("&")}`);
      })
      .catch((err) => {
        console.log(err);
        setReserveLoader(false);
      });
  };

  const handleImageError = (index) => {
    // Add the failed image index to the invalid list
    setValidImages((prev) => prev.filter((i) => i !== index));
    // If the current photo fails to load, move to the next one
    if (index === currentPhotoIndex) {
      handleNextPhoto();
    }
  };

  const handleImageLoad = (index) => {
    // Add the image index to the validImages list when it successfully loads
    setValidImages((prev) => {
      if (!prev.includes(index)) {
        return [...prev, index];
      }
      return prev;
    });
  };

  const handleImageClick = (index) => {
    setCurrentPhotoIndex(index); // Set the clicked image as the starting point
    setShowPhotoModal(true); // Open the modal
    // Initialize validImages with all indices, assuming they are valid until proven otherwise
    if (hotelDetails?.images) {
      setValidImages([...Array(hotelDetails.images.length).keys()]);
    }
  };

  // Navigation for the gallery modal
  const handlePrevPhoto = () => {
    const newIndex =
      currentPhotoIndex === 0
        ? hotelDetails?.images?.length - 1
        : currentPhotoIndex - 1;
    setCurrentPhotoIndex(newIndex);
    scrollThumbnailToCenter(newIndex);
  };

  const handleNextPhoto = () => {
    const newIndex =
      currentPhotoIndex === hotelDetails?.images?.length - 1
        ? 0
        : currentPhotoIndex + 1;
    setCurrentPhotoIndex(newIndex);
    scrollThumbnailToCenter(newIndex);
  };

  const handleThumbnailClick = (index) => {
    setCurrentPhotoIndex(index);
    scrollThumbnailToCenter(index);
  };

  // Scroll the selected thumbnail to the center of the horizontal scroll view
  const scrollThumbnailToCenter = (index) => {
    const thumbnailElement = thumbnailsRef.current?.children[index];
    if (thumbnailElement) {
      const container = thumbnailsRef.current;
      const containerWidth = container.offsetWidth;
      const thumbnailWidth = thumbnailElement.offsetWidth;
      const thumbnailOffsetLeft = thumbnailElement.offsetLeft;
      const scrollPosition =
        thumbnailOffsetLeft - containerWidth / 2 + thumbnailWidth / 2;
      container.scrollTo({
        left: scrollPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <hr style={{ color: "var(--light-grey)" }} />
      <Search
        tripId={tid}
        loc={locid}
        dates={checkdates}
        occupancies={occupancy}
        open={false}
        url={url}
        hotelname={hotelDetails?.name}
      />

      <div className="container mt-4 sdh">
        {error && (
          <div
            className="t-center p-3 d-flex align-items-center justify-content-center"
            style={{
              color: "var(--red-color)",
              backgroundColor: "#fdecea",
              gap: "10px",
              borderRadius: "8px",
            }}
          >
            <img src={NOHOTELIMG} alt="noHotel" style={{ width: "25px" }} />
            {error}
          </div>
        )}
        <h2>{loader ? <Skeleton height={30} /> : hotelDetails?.name}</h2>
        <div className="d-flex align-items-center justify-content-between f-wrap">
          <div className="d-flex align-items-center mt-2">
            <StarIcon sx={{ width: 20, color: "var(--yellow-color)" }} />
            <p className="ms-1 fs-8">
              {loader ? (
                <Skeleton height={20} width={100} />
              ) : (
                hotelDetails?.starRating
              )}
            </p>
            <LocationOnIcon className="ms-3" />
            <p className="ms-1 fs-8 w90">
              {loader ? (
                <Skeleton />
              ) : (
                `${hotelDetails?.contact?.address?.line1} ${hotelDetails?.contact?.address?.city?.name}, ${hotelDetails?.contact?.address.country?.name}`
              )}
            </p>
          </div>
          <div className="d-flex align-items-center">
            <button
              className="ms-3 btn-contained c-pointer"
              onClick={shareHotel}
            >
              Share Hotel
            </button>
            <button
              className="ms-3 btn-contained c-pointer"
              onClick={scrollToRooms}
            >
              Select a room
            </button>
          </div>
        </div>

        {/* Image Section */}
        <div className="hotel-images-container my-4">
          {/* Main Image */}
          <div className="main-image" onClick={() => handleImageClick(0)}>
            {loader ? (
              <Skeleton height={400} />
            ) : (
              <>
                <img
                  src={hotelDetails?.heroImage || hotelDetails?.images?.[0]}
                  alt="Hotel Main View"
                  className="imgclass"
                  onError={() => handleImageError(0)}
                  onLoad={() => handleImageLoad(0)}
                  loading="lazy"
                />
                {visibleImages === 0 && remainingImagesCount > 0 && (
                  <div className="main-overlay-text">
                    Show more ({remainingImagesCount})
                  </div>
                )}
              </>
            )}
          </div>

          {/* Grid of 6 Smaller Square Images */}
          <div className="small-images-grid">
            {loader
              ? Array(6)
                  .fill()
                  .map((_, index) => <Skeleton key={index} height={195} />)
              : hotelDetails?.images?.slice(1, 7)?.map((image, index) => (
                  <div
                    key={index}
                    className={`small-image ${
                      index === visibleImages - 1 ? "last-image" : ""
                    }`}
                    onClick={() => handleImageClick(index + 1)}
                  >
                    <img
                      src={image}
                      alt={`Hotel View ${index + 1}`}
                      className="imgclass"
                      onError={() => handleImageError(index + 1)}
                      onLoad={() => handleImageLoad(index + 1)}
                      loading="lazy"
                    />
                    {index === visibleImages - 1 &&
                      remainingImagesCount > 0 && (
                        <div className="overlay-text">
                          Show more ({remainingImagesCount})
                        </div>
                      )}
                  </div>
                ))}
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-lg-8 col-sm-8">
            <h3 className="mb-2">Overview</h3>
            {loader ? (
              <Skeleton height={20} count={4} />
            ) : (
              <div
                className="my-4 fs-8"
                dangerouslySetInnerHTML={{
                  __html: hotelDetails?.descriptions,
                }}
              />
            )}
            <hr className="mb-4 mt-4 hrColor" />
            <div>
              <h3 className="mb-2">This place Offers</h3>
              <div className="d-flex align-items-center justify-content-between flex-wrap">
                {hotelDetails?.facilities
                  .slice(0, showAll ? hotelDetails.facilities.length : 6)
                  .map((amdata, index) => {
                    const iconClass =
                      iconMapping[amdata?.groupId] || iconMapping["0"];
                    return (
                      <div
                        key={amdata.id}
                        className="d-flex mt-2 align-items-center"
                        style={{ minWidth: "30%" }}
                      >
                        {loader ? (
                          <Skeleton width={100} height={20} />
                        ) : (
                          <div
                            className="d-flex align-items-center py-1"
                            style={{ gap: "12px" }}
                          >
                            <i
                              className={`fa ${iconClass}`}
                              style={{ width: "12px", height: "auto" }}
                            ></i>
                            <p className="fs-8">{amdata.name}</p>
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
              {hotelDetails?.facilities?.length > 6 && (
                <button className="mt-4 btn-contained" onClick={handleShowAll}>
                  {showAll ? "Show less" : "Show all amenities"}
                </button>
              )}
            </div>
            <hr className="my-4 hrColor" />
            <div ref={roomsRef}>
              {loader ? <Skeleton width={100} height={30} /> : <h3>Rooms</h3>}
              {loader ? (
                <Skeleton width={"100%"} height={20} />
              ) : (
                <p>
                  Select from rates negotiated by your company and options that
                  are popular with you, your coworkers, and other business
                  travelers.
                </p>
              )}
              <div
                className="d-flex align-items-start justify-content-center"
                style={{ flexWrap: "wrap", gap: 20 }}
              >
                {roomDetails &&
                  roomDetails.map((rdata) => (
                    <div
                      key={rdata.id}
                      className="bxShadow p-3 pb-0 my-3 sdcard"
                      style={{ position: "relative" }}
                    >
                      {loader ? (
                        <Skeleton width={"100%"} height={"12rem"} />
                      ) : (
                        <Slider
                          images={roomImages}
                          dots={true}
                          mainstyle={{ height: "250px" }}
                        />
                      )}
                      {loader ? (
                        <Skeleton width={"100%"} height={"2rem"} />
                      ) : (
                        <div>
                          <p className="mt-2 fw-700">{rdata?.name}</p>
                          <p
                            className="mt-1 fs-8"
                            style={{ color: "var(--light-grey)" }}
                          >
                            {rdata?.sqft}
                          </p>
                        </div>
                      )}
                      {loader ? (
                        <Skeleton width={"30%"} height={"1rem"} />
                      ) : (
                        <div
                          className="d-flex align-items-center mt-1"
                          style={{ gap: "30", color: "var(--light-grey)" }}
                        >
                          <WifiIcon style={{ width: "15px", height: "15px" }} />
                          <AcUnitIcon
                            style={{ width: "15px", height: "15px" }}
                          />
                          <RestaurantIcon
                            style={{ width: "15px", height: "15px" }}
                          />
                        </div>
                      )}
                      <hr className="mb-1 mt-3 hrColor" />

                      {loader ? (
                        <Skeleton width={"10%"} height={"1rem"} />
                      ) : (
                        rdata?.rooms.map((room, index) =>
                          room?.cancellationPolicies &&
                          room?.cancellationPolicies.length !== 0 ? (
                            <>
                              <p className="fs-8">
                                {room?.boardBasis?.type === "HalfBoard"
                                  ? "Includes breakfast and one additional meal"
                                  : room?.boardBasis?.type === "BedAndBreakfast"
                                  ? "Includes breakfast"
                                  : room?.boardBasis?.description}
                              </p>

                              <p
                                className="fs-8 fw-700"
                                style={{
                                  color: "var(--yellow-color)",
                                }}
                              >
                                {room?.providerName}
                              </p>

                              <div
                                key={index}
                                className="d-flex align-items-center pb-3 justify-content-between"
                              >
                                <div>
                                  <p className="fs-8">
                                    For {room?.noOfDays} nights
                                  </p>
                                  <p
                                    className="fs-8"
                                    style={
                                      room?.refundability === "Refundable"
                                        ? { color: "var(--primary-color)" }
                                        : { color: "var(--red-color)" }
                                    }
                                  >
                                    {room?.refundability === "Refundable"
                                      ? "Refundable"
                                      : "Non-Refundable"}
                                  </p>
                                </div>
                                <div style={{ textAlign: "right" }}>
                                  <h4>
                                    {selectedCurrency?.symbol || "$"}{" "}
                                    {(
                                      (room?.totalRate *
                                        selectedCurrency?.value ?? 1) /
                                      parseInt(
                                        getDayDifference(checkIn, checkOut) *
                                          parseInt(occupancy?.rooms)
                                      )
                                    ).toFixed(2)}
                                  </h4>
                                  <p className="fs-6">average nightly</p>
                                  <p className="fs-8">
                                    {selectedCurrency?.symbol || "$"}{" "}
                                    {(
                                      room?.totalRate *
                                        selectedCurrency?.value ?? 1
                                    ).toFixed(2)}
                                  </p>
                                  <p className="fs-6">Sub Total Price</p>
                                  {room?.hotelfee && (
                                    <p className="fs-6">
                                      + daily hotel fee {room.hotelfee}
                                    </p>
                                  )}
                                  <button
                                    className="select-btn fw-600 c-pointer"
                                    style={
                                      selectedRoom?.id === room?.id
                                        ? {
                                            backgroundColor:
                                              "var(--primary-color)",
                                            color: "white",
                                          }
                                        : {}
                                    }
                                    onClick={() => setSelectedRoom(room)}
                                  >
                                    {room?.occupancies.length > 1
                                      ? `Book ${room?.occupancies.length} rooms`
                                      : "Book"}
                                  </button>
                                </div>
                              </div>
                              {room &&
                                room?.cancellationPolicies &&
                                room?.cancellationPolicies[0]?.rules &&
                                room?.cancellationPolicies[0]?.rules.length !==
                                  0 &&
                                room?.refundability === "Refundable" && (
                                  <div
                                    style={
                                      selectedRoom?.id === room?.id
                                        ? { display: "block" }
                                        : { display: "none" }
                                    }
                                  >
                                    <p
                                      className="fs-8"
                                      style={{ color: "var(--yellow-color)" }}
                                    >
                                      Cancellation Policy
                                    </p>

                                    <p className="fs-6">
                                      •{" "}
                                      {room?.cancellationPolicies[0]?.rules[0]
                                        .value === 0
                                        ? "No cancellation fee "
                                        : ` A cancellation fee of  ${
                                            room?.cancellationPolicies[0]
                                              ?.rules[0].valueType ===
                                            "Percentage"
                                              ? `${room?.cancellationPolicies[0]?.rules[0].value}% of the total amount`
                                              : `$${room?.cancellationPolicies[0]?.rules[0].value.toFixed(
                                                  2
                                                )}`
                                          }`}{" "}
                                      will be charged if you cancel between{" "}
                                      {
                                        room?.cancellationPolicies[0]?.rules[0].start.split(
                                          "T"
                                        )[0]
                                      }{" "}
                                      {room?.cancellationPolicies[0]?.rules[0].start
                                        .split("T")[1]
                                        .split(":")
                                        .slice(0, 2)
                                        .join(":")}{" "}
                                      and{" "}
                                      {
                                        room?.cancellationPolicies[0]?.rules[0].end.split(
                                          "T"
                                        )[0]
                                      }{" "}
                                      {room?.cancellationPolicies[0]?.rules[0].end
                                        .split("T")[1]
                                        .split(":")
                                        .slice(0, 2)
                                        .join(":")}
                                    </p>
                                    <p className="fs-6">
                                      •{" "}
                                      {room?.cancellationPolicies[0]?.rules[
                                        room?.cancellationPolicies[0]?.rules
                                          .length - 1
                                      ].value === 0
                                        ? "No cancellation fee "
                                        : ` 100% cancellation fee of  `}{" "}
                                      will be charged if you cancel after{" "}
                                      {
                                        room?.cancellationPolicies[0]?.rules[0].end.split(
                                          "T"
                                        )[0]
                                      }{" "}
                                      {room?.cancellationPolicies[0]?.rules[0].end
                                        .split("T")[1]
                                        .split(":")
                                        .slice(0, 2)
                                        .join(":")}
                                    </p>
                                  </div>
                                )}
                              {index !== rdata.rooms.length - 1 && (
                                <hr className="mb-1 mt-2 hrColor" />
                              )}
                            </>
                          ) : (
                            <></>
                          )
                        )
                      )}
                    </div>
                  ))}
              </div>
            </div>
          </div>
          <div
            className="col-lg-4 col-sm-4 sticky-column hd-rs-sdl"
            style={{ height: "fit-content" }}
          >
            <div className="bxShadow px-4 py-3" style={{ borderRadius: "8px" }}>
              {loader ? (
                <Skeleton height={60} />
              ) : (
                <div className="d-flex align-items-center justify-content-between mt-4">
                  <div
                    className=""
                    style={{
                      borderBottom: "1px solid var(--light-grey)",
                      width: "48%",
                    }}
                  >
                    <p className="fs-8">Check in</p>
                    <p className="mt-2 ms-1">
                      {formatDateToEEE_MM_d(checkIn, "UTC")}
                    </p>
                  </div>
                  <div
                    className=""
                    style={{
                      borderBottom: "1px solid var(--light-grey)",
                      width: "48%",
                    }}
                  >
                    <p className="fs-8">Check out</p>
                    <p className="mt-2 ms-1">
                      {formatDateToEEE_MM_d(checkOut, "UTC")}
                    </p>
                  </div>
                </div>
              )}

              {loader ? (
                <Skeleton height={20} />
              ) : (
                selectedRoom && (
                  <div className="d-flex align-items-center justify-content-between my-2">
                    <p className="fs-8 w80">
                      {selectedRoom?.name} * {selectedRoom?.occupancies.length}
                    </p>
                    <p className="">
                      {selectedCurrency?.symbol || "$"}{" "}
                      {(
                        selectedRoom?.totalRate * selectedCurrency?.value ?? 1
                      ).toFixed(2)}
                    </p>
                  </div>
                )
              )}
              <hr className="my-2 hrColor" />
              {loader ? (
                <Skeleton height={20} />
              ) : (
                selectedRoom && (
                  <div className="d-flex align-items-center justify-content-between my-2">
                    <p className="fs-8">Sub Total</p>
                    <p className="fw-700">
                      {selectedCurrency?.symbol || "$"}{" "}
                      {(
                        selectedRoom?.totalRate * selectedCurrency?.value ?? 1
                      ).toFixed(2)}
                    </p>
                  </div>
                )
              )}
              <button
                className="btn-contained my-2 w100 d-flex align-items-center justify-content-center"
                onClick={addRoom}
              >
                <p className="me-2">Reserve</p>
                {reserveLoader && <Spinner />}
              </button>
              <p className="my-2 fs-8" style={{ textAlign: "center" }}>
                {selectedRoom?.additionalCharges &&
                selectedRoom.additionalCharges.length > 0
                  ? `A resort fee of 
       ${selectedRoom.additionalCharges.reduce(
         (sum, item) => sum + (item?.charge?.amount || 0),
         0
       )} $ will be charged at the hotel`
                  : ""}
              </p>
              <p className="my-2 fs-6" style={{ textAlign: "center" }}>
                You won't be charged yet
              </p>
            </div>
          </div>
        </div>
        <div>
          <hr className="my-4 hrColor" />
          <div className="bxShadow p-2">
            {loader ? (
              <Skeleton height={400} />
            ) : (
              <GoogleMap
                onemarkerData={hotelDetails?.geoCode}
                styles={{ height: "24rem" }}
                zoom={15}
              />
            )}
          </div>
          <hr className="mb-4 hrColor" />
        </div>
      </div>

      {/* Updated Gallery Modal */}
      <Modal
        open={showPhotoModal}
        size={"lg"}
        onClose={() => setShowPhotoModal(false)}
      >
        <div className="gallery-modal">
          {/* Main Image with Navigation */}
          <div className="gallery-modal-main-image">
            {hotelDetails?.images?.length > 0 ? (
              <>
                <img
                  src={hotelDetails?.images[currentPhotoIndex]}
                  alt={`Hotel Image ${currentPhotoIndex + 1}`}
                  onError={() => handleImageError(currentPhotoIndex)}
                  onLoad={() => handleImageLoad(currentPhotoIndex)}
                />
                {hotelDetails?.images?.length > 1 && (
                  <>
                    <button
                      className="gallery-modal-nav left"
                      onClick={handlePrevPhoto}
                    >
                      <ChevronLeftIcon />
                    </button>
                    <button
                      className="gallery-modal-nav right"
                      onClick={handleNextPhoto}
                    >
                      <ChevronRightIcon />
                    </button>
                  </>
                )}
              </>
            ) : (
              <p>No photos available.</p>
            )}
          </div>

          {/* Thumbnails */}
          <div className="gallery-modal-thumbnails" ref={thumbnailsRef}>
            {hotelDetails?.images?.map((image, index) => (
              <div
                key={index}
                className={`gallery-modal-thumbnail ${
                  currentPhotoIndex === index ? "active" : ""
                } ${validImages.includes(index) ? "" : "hidden"}`}
                onClick={() => handleThumbnailClick(index)}
              >
                <img
                  src={image}
                  alt={`Thumbnail ${index + 1}`}
                  onError={() => handleImageError(index)}
                  onLoad={() => handleImageLoad(index)}
                />
              </div>
            ))}
          </div>
        </div>
      </Modal>

      <Modal open={openLogin} onClose={() => setOpenLogin(false)} size="sm">
        <div className="t-center">
          <h4 className="mb-3">Login to Reserve a hotel</h4>
          <button
            className="mt-2 btn-contained"
            onClick={() => navigate("/login")}
          >
            Click here to Login/Signup
          </button>
        </div>
      </Modal>
      {selectedRoom !== null &&
        selectedRoom !== "" &&
        selectedRoom !== undefined && (
          <button
            className="btn-contained my-2 w100 d-flex align-items-center justify-content-center reserve-btn-sdl "
            style={{ position: "fixed", bottom: "0px", fontSize: "12px" }}
            onClick={addRoom}
          >
            <p className="d-flex align-items-center justify-content-center">
              {" "}
              <span className="me-2">Reserve </span>{" "}
              {reserveLoader && <Spinner />}
            </p>
          </button>
        )}
    </>
  );
};

export default SearchDetail;
